import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Row, Col, Tabs, DatePicker, Select, message} from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';


const API_HOST_URL = process.env.REACT_APP_API_URL

class ResetPasswordForm extends Component {
    
    state = {
        confirmDirty: false,
        loading: false
    }
    
    componentDidMount(){
    }
    
    handleFormSubmit = (event)=> {
        event.preventDefault();
        console.log("Reset Password Form submitted!")
        
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                    message.warning('Ensure you have filled in your new password.');
                return;
            }
            this.setState({
              loading: true
            })

            // console.log("use values: ", {...this.props.currentUserWithPermissionData} )
            // console.log(values);
            
            axios.put(`${API_HOST_URL}/api/systemsetup/change-password/`, {
              old_password: values.oldpassword,
              new_password: values.password
            },
            {
              headers: {Authorization: 'Token ' + this.props.token}  
          })
        .then(res => {
            this.setState({
              loading: false
            })
            form.resetFields();
            console.log(res)
            message.success("Password changed successfully",10)
        })
        .catch(error =>{
          this.setState({
            loading: false
          })
          form.resetFields();
            console.log(error.response.data)
            message.error(JSON.stringify(error.response.data),10)
            } );
        
    });
}

handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Passwords you have entered do not match');
    } else {
      callback();
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  }

render() {
    const { getFieldDecorator } = this.props.form;
    const { Option } = Select;
    
    return (
        <div>
            <Form onSubmit={this.handleFormSubmit}>
    <Row type="flex">

    <Col span={8} style={{ padding: 6}}>
    <Form.Item
          label="Old Password"
        >
          {getFieldDecorator('oldpassword', {
            rules: [{
              required: true, message: 'Please input your old password!',
            }],
          })(
            <Input type="password" />
          )}
        </Form.Item>

    <Form.Item
          label="New Password"
        >
          {getFieldDecorator('password', {
            rules: [{
              required: true, message: 'Please input your new password!',
            }, {
              validator: this.validateToNextPassword,
            }],
          })(
            <Input type="password" />
          )}
        </Form.Item>

    <Form.Item
          label="Confirm New Password"
        >
          {getFieldDecorator('confirm', {
            rules: [{
              required: true, message: 'Please confirm your new  password!',
            }, {
              validator: this.compareToFirstPassword,
            }],
          })(
            <Input type="password" onBlur={this.handleConfirmBlur} />
          )}
        </Form.Item>
    </Col>
    </Row>
    
    <Form.Item>
    <Button loading={this.state.loading} type="primary" htmlType="submit">Reset Password</Button>
    </Form.Item>
    </Form>
    
    </div>
);
}
}

const PasswordReset = Form.create({ name: 'password_reset_form' })(ResetPasswordForm)

const mapStateToProps = state => {
    return {
      isAuthenticated: state.token !== null,
      loggedInEmployee: state.loggedInEmployee,
      userPermissions: state.userPermissions,
      currentUserWithPermissionData:  state.currentUserWithPermissionData,
      token: state.token
    }
  }
  
  export default connect(mapStateToProps, null)(PasswordReset);
  
// export default PasswordReset;